Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TikTokCommentContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.TikTokCommentContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.sub_type == 'tiktok-comment'